import Vue from "vue";
import Router from "vue-router";
import home from "@/components/common/Home";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: home,
      redirect: "/dashboard",
      children: [   
        {
          path: "/order",
          component: resolve =>
            require(["../components/page/Order.vue"], resolve),
          meta: {
            title: "投标订单"
          }
        },
        {
          path: "/yanzhen",
          component: resolve =>
            require(["../components/page/yanzhen.vue"], resolve),
          meta: {
            title: "保单验真"
          }
        },
        {
          path: "/companyInfo",
          component: resolve =>
            require(["../components/page/CompanyInfo.vue"], resolve),
          meta: {
            title: "企业信息"
          }
        },
        {
            path: "/user",
            component: resolve =>
              require(["../components/page/User.vue"], resolve),
            meta: {
              title: "账户信息"
            }
        },

        // {
        //   path: "/faPiao",
        //   component: resolve =>
        //     require(["../components/page/FaPiao.vue"], resolve),
        //   meta: {
        //     title: "发票信息"
        //   }
        // },

        {
          path: "/zhuanzhangDianhui",
          component: resolve =>
            require(["../components/page/zhuanzhangDianhui"], resolve),
          meta: {
            title: "转账或电汇",
            hidden:true
          }
        },
        {
            path: "/workerorder",
            component: resolve =>
              require(["../components/page/WorkerOrder.vue"], resolve),
            meta: {
              title: "工资保险订单",
              hidden:true
            }
          },
      ]
    },
    {
      path: "/dashboard",
      component: resolve =>
        require(["../components/page/Dashboard.vue"], resolve),
      meta: {
        title: "主界面"
      }
    },
    {
      path: "/shenqingbaohan",
      component: resolve =>
        require(["../components/page/shenqingbaohan.vue"], resolve),
      meta: {
        title: "申请保函"
      }
    },      
    {
      path: "/login",
      component: resolve => require(["../components/page/Login.vue"], resolve),
      meta: {
        title: "登录"
      }
    },
    {
      path: "/zhuce",
      component: resolve => require(["../components/page/Zhuce.vue"], resolve),
      meta: {
        title: "注册"
      }
    },
    {
      path: "/yindao",
      component: resolve => require(["../components/page/yindao.vue"], resolve),
      meta: {
        title: "引导"
      }
    },
    {
      path: "/zhengce",
      component: resolve => require(["../components/page/zhengce.vue"], resolve),
      meta: {
        title: "隐私权政策"
      }
    },
    {
      path: "/xieyi",
      component: resolve => require(["../components/page/xieyi.vue"], resolve),
      meta: {
        title: "用户服务协议"
      }
    },
    {
      path: "/renzheng",
      component: resolve => require(["../components/page/Renzheng.vue"], resolve),
      meta: {
        title: "企业认证"
      }
    },
    {
      path: "/forgetPwd",
      component: resolve => require(["../components/page/forgetPwd.vue"], resolve),
      meta: {
        title: "忘记密码"
      }
    },
    {
      path: "/pass",
      component: resolve => require(["../components/page/pass.vue"], resolve),
      meta: {
        title: "修改密码"
      }
    },
    {
      path: "/nongmingongXuzhi",
      component: resolve => require(["../components/page/nongmingongXuzhi.vue"], resolve),
      meta: {
        title: "农民工工资支付履约保证保险办理须知"
      }
    },
    {
      path: "/zhucesaoma",
      component: resolve =>
        require(["../components/page/Zhucesaoma.vue"], resolve),
      meta: {
        title: "公众号关注"
      }
    },
    {
      path: "/404",
      component: resolve => require(["../components/page/404.vue"], resolve)
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js